export interface Page<T> {
  readonly items: ReadonlyArray<T>;
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
  readonly hasMore: boolean;
}

/**
 * Structurally what the spec's `PageResponse*` schemas are: both members optional, because
 * springdoc declares them so. Keeping them optional here is what lets every generated page type be
 * passed to `mapPage` without a cast.
 */
export interface ApiPage<T> {
  readonly data?: ReadonlyArray<T> | null;
  readonly meta?: ApiPageMeta | null;
}

export interface ApiPageMeta {
  readonly total?: number | null;
  readonly page?: number | null;
  readonly pageSize?: number | null;
}

export interface PagedQuery {
  readonly page?: number;
  readonly pageSize?: number;
}

export const DEFAULT_PAGE_SIZE = 20;

export function emptyPage<T>(pageSize: number = DEFAULT_PAGE_SIZE): Page<T> {
  return { items: [], total: 0, page: 1, pageSize, hasMore: false };
}

export function mapPage<TDto, TModel>(
  envelope: ApiPage<TDto>,
  mapItem: (dto: TDto) => TModel
): Page<TModel> {
  const items = (envelope.data ?? []).map(mapItem);
  const page = envelope.meta?.page ?? 1;
  const pageSize =
    envelope.meta?.pageSize ?? (items.length || DEFAULT_PAGE_SIZE);
  const total = envelope.meta?.total ?? items.length;

  return { items, total, page, pageSize, hasMore: page * pageSize < total };
}
